// Angular
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { GeneralSearchService } from '../../../../../core/services/general-search.service';

@Component({
  selector: 'kt-search-dropdown',
  templateUrl: './search-dropdown.component.html',
  styleUrls: ['search-dropdown.component.scss'],
})
export class SearchDropdownComponent implements OnInit {
  // Public properties
  @Input() layout = 'dropdown';
  // Set icon class name
  @Input() icon = 'flaticon2-search-1';

  // Set true to icon as SVG or false as icon class
  @Input() useSVG: boolean;

  @Input() type: 'brand' | 'success' | 'warning' = 'success';

  @ViewChild('searchInput', { static: true }) searchInput: ElementRef;
  @ViewChild('dropdown', { static: true }) dropdown;

  data: any[] = null;
  loading: boolean;
  searchText = '';
  form: any;
  startValue = '';
  isLoadingResult = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    public dialog: MatDialog,
    private generalSearchService: GeneralSearchService,
  ) {}

  /**
   * On init
   */
  ngOnInit(): void {
    // simulate result from API
    this.form = this.fb.group({
      search: new FormControl(),
    });
  }

  get searchController() {
    return this.form.get('search');
  }
  /**
   * Search
   * @param e
   */
  search(e) {
    const value = e.target.value;
    if (value.length <= 3) {
      return;
    }
    this.isLoadingResult = true;
    this.generalSearchService.generalSearch(value).subscribe((result) => {
      if (result && result.data) {
        this.generalSearchService.setCurrent(result.data);
        this.generalSearchService.term$.next(value);
        this.router.navigateByUrl('/search/result-dashboard');
        this.isLoadingResult = false;
      }
    });
  }

  /**
   * Clear search
   *
   */
  clear() {
    this.data = null;
    this.searchInput.nativeElement.value = '';
  }

  openChange() {
    setTimeout(() => this.searchInput.nativeElement.focus());
  }
}
